// extracted by mini-css-extract-plugin
module.exports = {"pageHeaderInfo":"PageHeaderInfo_pageHeaderInfo__1czcA","infoBox":"PageHeaderInfo_infoBox__3uxTX","label":"PageHeaderInfo_label__1a7kI"};